import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import MainPageComponent from "../../components/page/MainPageComponent";
import useURL from '../../hooks/useURL';

function UserUnauthorizedView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'No autorizado', href: '' }
    ];

	const local = useURL().local;

	return (
		<div>
            <MainPageComponent requireAuthentication={false} path={breadcrumbPath} >
				<CenterCenterVerticalContainer justify="center" padding="3">
					<div className="d-flex flex-column flex-grow-1"
						style={{
							maxWidth: '25rem'
						}}
					>
						<h1>No ha iniciado sesion</h1>
						<a
							href={local + "/user/login"}
							target="_self"
							rel="noreferrer"
							id="TooltipExample"
						>
							Iniciar sesion
						</a>
					</div>

				</CenterCenterVerticalContainer>
			</MainPageComponent>
		</div>
	);
}

export default UserUnauthorizedView;